import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { AllProjectComponent } from './all-project.component';
import { DPCustomerComponent } from './dp-customer.component';
import { DPCustomerCreateComponent } from './dp-customer-create.component';
import { DPCustomerDetailComponent } from './dp-customer-detail.component';
import { DPAccountComponent } from './dp-accounts-component';
import { DPAccountCreateComponent } from './dp-account-create.component';
import { DPAccountDetailComponent } from './dp-account-detail.component';
import { DPUsersComponent } from './dp-users.component';
import { DPSubscriptionsComponent } from './dp-subscriptions.component';
import { DPProjectComponent } from './dp-project.component';
import { SharedModule } from '../shared/shared.module';
import { DPModuleCreateComponent } from './dp-module-create.component';
import { DPModuleDetailComponent } from './dp-module-detail.component';
import { DPUserDetailComponent } from './dp-user-detail.component';
import { DPUserCreateComponent } from './dp-user-create.component';
import { DPProjectCreateComponent } from './dp-project-create.component';
import { DPProjectDetailComponent } from './dp-project-detail.component';
import { DPTimeSheetCreateComponent } from './dp-timesheet-create.component';
import { DPTimeSheetDetailComponent } from './dp-timesheet-detail.component';
import { BrowserModule } from '@angular/platform-browser';
import { DPCustomerService } from './dp-customer.service';
import { DPAccountService } from './dp-accounts.service';

import { DPUserService } from './dp-user.service';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { DPSubscriptionService } from './dp-subscriptions.service';
import { CustomerHubComponent } from '../portalv1/components/customer-hub/customer-hub.component';
import {CommonModule} from '@angular/common';

@NgModule({
    declarations: [AllProjectComponent, DPCustomerComponent,
        DPCustomerCreateComponent, DPCustomerDetailComponent,
        DPAccountComponent, DPAccountCreateComponent, DPAccountDetailComponent,
        DPUsersComponent, DPSubscriptionsComponent, DPProjectComponent, DPModuleCreateComponent,
        DPModuleDetailComponent, DPUserDetailComponent, DPUserCreateComponent, DPProjectCreateComponent,
        DPProjectDetailComponent, DPTimeSheetCreateComponent, DPTimeSheetDetailComponent, CustomerHubComponent
    ],
    imports: [HttpModule, FormsModule, SharedModule, BrowserModule, SimpleNotificationsModule.forRoot(), CommonModule],
    exports: [],
    providers: [DPCustomerService, DPAccountService, DPUserService, DPSubscriptionService]
})
export class Portalv1Module {

}



// WEBPACK FOOTER //
// ./src/app/portalv1/portalv1.module.ts